export default __webpack_public_path__ + "static/media/image-ph-study-report-n-m@3x.e8847d3e.png";